module.exports = __webpack_public_path__ + "img/1.138d5f62.jpg";